<template>
  <div class="container-ketqua">
    <div class="titleBar" style="display: block;">
      <div class="title">Kết quả</div>
    </div>
    <div class="filterBlock">
      <div class="filterRow">
        <select @change="onChange($event)">
          <option value="76">{{$t('tables.76')}}</option>
          <option value="73">{{$t('tables.73')}}</option>
          <option value="74">{{$t('tables.74')}}</option>
          <option value="75">{{$t('tables.75')}}</option>
          <option value="77">{{$t('tables.77')}}</option>
          <option value="78">{{$t('tables.78')}}</option>
        </select>
        <!-- <div id="date_button" class="filter dropdown-date">
          <div class="selected" title="Chọn ngày">
            <input name="txtDate" type="text" value="01/23/2020" id="txtDate" class="date-input" readonly="readonly" />
          </div>
        </div> -->
        <!-- <input type="submit" name="Button1" value="Tìm kiếm" id="Button1" title="Tìm kiếm" class="filter primary" /> -->
      </div>
    </div>
    <div class="wrapbox">
      <div v-if="data === null">
        <div class="preloader">
          <div class="spin">
            <div class="spin-circle"></div>
            <div class="spin-circle"></div>
            <div class="spin-circle"></div>
            <div class="spin-circle"></div>
            <div class="spin-circle"></div>
          </div>
        </div>
      </div>
      <div v-if="data !== null">
        <XocDiaResult
          v-if="tableId === '78'"
          :content="content"
          :page="page"
          @first-Page="firstPage"
          @previous-Page="previousPage"
          @next-Page="nextPage"
          @last-Page="lastPage"
        />
        <TaiXiuResult
          v-if="tableId === '77'"
          :content="content"
          :page="page"
          @first-Page="firstPage"
          @previous-Page="previousPage"
          @next-Page="nextPage"
          @last-Page="lastPage"
        />
        <BaccaratResult
          v-if="tableId === '73' || tableId === '74' || tableId === '75' || tableId === '76'"
          :content="content"
          :page="page"
          @first-Page="firstPage"
          @previous-Page="previousPage"
          @next-Page="nextPage"
          @last-Page="lastPage"
        />
      </div>
      <span  class="gmtMessage">
        <p class='gmtMessage'>
          <span>{{ $t('content.pay_attention') }}: </span>{{ $t('content.footer') }}
        </p>
      </span>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import TaiXiuResult from '@components/content/result/bigsmall-detail.vue'
import XocDiaResult from '@components/content/result/xocdia-detail.vue'
import BaccaratResult from '@components/content/result/baccarat-result.vue'

const PAGE_SIZE = 20;

export default {
  components: {
    TaiXiuResult,
    XocDiaResult,
    BaccaratResult,
},
  data() {
    return {
      page: "",
      tableId: 58,
      currentPage: 1,
      data: null,
    }
  },
  computed: {
    ...mapState('result', ['content', 'total']),
  },
  watch: {
    content: function(newVal){
      this.data = newVal;
    },
    total: function(newVal){
      const pages = Math.round(newVal/PAGE_SIZE);
      this.page = `Trang ${this.currentPage}/${pages}`;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions('result', ['getRoundsResultHistory']),
    getData: function(e){
      const pages = Math.ceil(this.total/PAGE_SIZE);
      this.page = `Trang ${this.currentPage}/${pages}`;
      const limit = PAGE_SIZE;
      const page = this.currentPage - 1;
      const tableId = this.tableId;
      const params = { limit, page, tableId };
      this.getRoundsResultHistory(params);
    },
    previousPage(event, value) {
      if(this.currentPage > 1){
        this.currentPage -= 1;
        this.getData();
      }
    },
    nextPage(event, value) {
      const pages = Math.ceil(this.total/PAGE_SIZE);
      if(this.currentPage < pages){
        this.currentPage += 1;
        this.getData();
      }
    },
    firstPage(event, value) {
      this.currentPage = 1;
      this.getData();
    },
    lastPage(event, value) {
      this.currentPage = Math.ceil(this.total/PAGE_SIZE);
      this.getData();
    },
    onChange(event) {
      this.data = null;
      const tableId = event.target.value;
      this.tableId = tableId;
      this.getData();
    }
  }
}
</script>

<style>


</style>
